var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 16.2v-6.1h2l.2-2.4h-2.2V6.1c0-.6.2-1.1 1.2-1.1h1.2V2.9c-.2 0-1-.1-1.9-.1-1.9 0-3.1 1.1-3.1 3.1v1.8h-2V10h2.1v6.2h2.5z"
  })));
};
export default SvgSocialFacebook;